/* permittedCharacter(String): It is a string that contains the characters that are not allowed to be entered in the text field.The Characters should be enclosed in square brackets. 
    For example, if you want to restrict the characters %, <, >, $, ', " then the permittedCharacter string should be "[<%$'"]", '^[a-zA-Z0-9]+$' for all special characters and space
*/
/* permittedCharacter(String): It is a RegularExpression string that contains the characters that are allowed to be entered in the text field.The Characters should be enclosed in square brackets. 
    For example, if you want only alphanumeric  and underscore then the permittedCharacter string should be '^[a-zA-Z0-9_]*$', '^[a-zA-Z0-9]+$' 
    Another example if first character to be only alphabet and rest can be alphanumeric then the permittedCharacter string should be "^[a-zA-Z][a-zA-Z0-9]*$"
*/

import React, { useEffect } from "react";
import "../../cssfiles/homepage.css";
import TextField from "@mui/material/TextField";
import { useSelector } from "react-redux";
import { NoLuggageOutlined } from "@mui/icons-material";
import InputAdornment from '@mui/material/InputAdornment';

export default function CustomTextField({
  id,
  defaultValue,
  width,
  fontSize,
  disabled,
  maxLength,
  onChange,
  placeholder,
  permittedCharacters,
  errorText,
  type,
  multiline,
  rows,
  maxRows,
  minRows,
  prefix, 
  suffix,
}) {
  const themechange = useSelector((state) => state.themedata.theme);
  const [val, setval] = React.useState("");
  const [error, setError] = React.useState("");
  const [permittedCharacter, setPermittedCharacter] = React.useState("");

  useEffect(() => {
    setval(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    {
      let re = new RegExp(permittedCharacters);
      setPermittedCharacter(re);
    }
  }, [permittedCharacters]);

  return (
    <TextField
      id={id}
      type={type ? type : "text"}
      defaultValue={defaultValue ? defaultValue : null}
      disabled={disabled != null ? disabled : false}
      required
      placeholder={placeholder ? placeholder : null}
      value={val}
      variant="standard"
      multiline = { multiline ? multiline : false }
      rows = {rows ? rows : null}
      maxRows = {maxRows ? maxRows : null}
      minRows = {minRows ? minRows : null}
      helperText={error} // error message
      error={error} // set to true to change the border/helperText color to red !newValue.match(permittedCharacter)
      onChange={(e) => {
        const newValue = e.target.value;
        if (permittedCharacters) {
          if (newValue.length != 0) {
            if (permittedCharacter.test(newValue)) {
              setError("");
              // setName(newValue); // only set when successful
              setval(e.target.value);
              onChange(e.target.value, e);
            } else {
              setError(errorText);
            }
          } else {
            setval(e.target.value);
            onChange(e.target.value, e);
          }
        } else {
          setval(e.target.value);
          onChange(e.target.value, e);
        }
      }}
      //label="Label"
      inputProps={{ maxLength: maxLength ? maxLength : 250 }}
      InputProps={{
        startAdornment: prefix ? (
          <InputAdornment 
            position="start"
            sx={{
              color: themechange === "light" ? "#3C3C3C" : "#C1C1C1",
              fontSize: fontSize ? `${fontSize}px` : "16px",
              fontFamily: "Roboto",
              fontWeight: "700",
              "& .MuiTypography-root": {
                color: themechange === "light" ? "#3C3C3C" : "#C1C1C1",
                fontSize: fontSize ? `${fontSize}px` : "16px",
                fontFamily: "Roboto",
                fontWeight: "700",
              }
            }}
          >
            {prefix}
          </InputAdornment>
        ) : null,
        endAdornment: suffix ? (
          <InputAdornment 
            position="end"
            sx={{
              color: themechange === "light" ? "#3C3C3C" : "#C1C1C1",
              fontSize: fontSize ? `${fontSize}px` : "16px",
              fontFamily: "Roboto",
              fontWeight: "700",
              "& .MuiTypography-root": {
                color: themechange === "light" ? "#3C3C3C" : "#C1C1C1",
                fontSize: fontSize ? `${fontSize}px` : "16px",
                fontFamily: "Roboto",
                fontWeight: "700",
              }
            }}
          >
            {suffix}
          </InputAdornment>
        ) : null,
      }}
      sx={{
        width: width ? `${width}px` : "94px",
        "& .MuiInputBase-input:focus": {
          color: "#008CD7",
        },
        "& .MuiInputBase-root": {
          fontFamily: "Roboto",
          fontSize: fontSize ? `${fontSize}px` : "16px",
          fontWeight: "700",
          color: themechange === "light" ? "#3C3C3C" : "#C1C1C1",
          //color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
        },
        "& .MuiInputBase-input.Mui-disabled": {
          WebkitTextFillColor: themechange === "light" ? "#C1C1C1" : "#3C3C3C",
          //WebkitBorderFillColor: themechange === 'light' ? '#C1C1C1' : '#3C3C3C',
        },
        // '& .MuiInput-underline.Mui-disabled':{
        //     color: themechange === 'light' ? '#C1C1C1' : '#pink',
        // },
        "& .MuiInput-root .MuiInputBase-input": {
          padding: 0,
        },
        "& .MuiInputBase-root::before": {
          //borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
          borderBottom: `1px solid ${
            (disabled != null ? disabled : false) == true
              ? themechange === "light"
                ? "#C1C1C1"
                : "#3C3C3C"
              : themechange === "light"
              ? "#3C3C3C"
              : "#C1C1C1"
          }`,
        },
        "& ::-webkit-input-placeholder": {
          color: themechange === "light" ? "#3C3C3C" : "#C1C1C1",
        },
        "& .MuiInputBase-root::after": {
          borderBottom: "2px solid #008CD7",
        },
        "& .Mui-error": {
          color: "var(--RedBaseColor)",
        },
      }}
    />
  );
}